import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenece la pantalla (encabezado de la bandeja). */
const SECCION = 'Reproducción Animal (REPRO)';

/**
 * Sección de Reproducción Animal. De sus tres servicios del RT-52 solo el
 * espermograma tiene formato cargado (IHIMV-RT-21 REPRO); los otros dos siguen
 * entrando por la bandeja genérica hasta que se defina el suyo.
 */
export const reproduccionRoutes: Routes = [
  {
    path: 'reproduccion/espermograma',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Espermograma',
    data: {
      pantalla: 'ESPERMOGRAMA',
      breadcrumb: SECCION,
      titulo: 'Espermograma',
      permiso: Permiso.ESPERMOGRAMA_VER,
    },
  },
  {
    path: 'reproduccion/espermograma/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'ESPERMOGRAMA',
      permiso: [Permiso.ESPERMOGRAMA_RESULTADOS, Permiso.ESPERMOGRAMA_VER],
    },
    loadComponent: () =>
      import('./pages/espermograma-resultados/espermograma-resultados.page').then(
        (m) => m.EspermogramaResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Espermograma',
  },
];
